module.exports = __webpack_public_path__ + "img/1.7d624bf0.png";